<template>
  <v-row no-gutters>
    <v-col v-for="colIndex in numberOfColumns" :key="colIndex" cols="12" md="12" lg="12">
      <v-sheet class="">
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        ></v-skeleton-loader>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashChartListingLoader",
  data() {
    return {
      numberOfColumns: 1,
    };
  },
};
</script>
